import { render, staticRenderFns } from "./RecursoGrupo.vue?vue&type=template&id=51f27170&scoped=true"
import script from "./RecursoGrupo.vue?vue&type=script&lang=js"
export * from "./RecursoGrupo.vue?vue&type=script&lang=js"
import style0 from "./RecursoGrupo.vue?vue&type=style&index=0&id=51f27170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f27170",
  null
  
)

export default component.exports